export const CookiesENUSTranslations = {
  cookiesText:
    'We use cookies to provide you with a better experience, improve performance, analyze how you interact with our site and personalize content. Also, by clicking the button on the side, you consent cookies.',
  cookiesButtonText: 'Accept cookies',
};
